import { MacBookWindow } from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { contactFormId } from '../const';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={<>XRPL Blockchain Development Services</>}
        description={
          <>
            Ready to Build on the XRPL?
            <br />
            Do it with the best blockchain development team in the Web3 space
          </>
        }
        buttonText="Let's talk!"
        buttonHandleOnClick={() => scrollToElement(contactFormId)}
        buttonLink="/contact"
        gradient="lightBlue"
      />
    </>
  );
};
